import { render, staticRenderFns } from "./next-query.vue?vue&type=template&id=3703e152&"
import script from "./next-query.vue?vue&type=script&lang=ts&"
export * from "./next-query.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports